import { Injectable } from '@angular/core';
import { MaskPipe } from 'ngx-mask';

@Injectable({
  providedIn: 'root'
})
export class StringExtensionService {

  constructor(private maskPipe: MaskPipe,) { }

  isNullOrEmpty(value: any): boolean {
    return value === undefined || value === null || value === '';
  }

  getTelefoneFormatado(ddd: string, telefone: string): string {
    if (!ddd) return this.maskPipe.transform(telefone, '0000-0000');

    const numero = ddd + telefone;
    if (numero.length === 10) {
      return this.maskPipe.transform(numero, '(00) 0000-0000');
    } else {
      return this.maskPipe.transform(numero, '(00) 0 0000-0000');
    }
  }
}
